<!--171-->
<boi-form-numeric-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [isCurrency]="true" [propertyNames]="['RemortgageUse.ReMortgageHomeImprovement']"
  [labelName]="referenceDataLabels.ReMortgageHomeImprovement"
  [(value)]="mortgageApplication.RemortgageUse.ReMortgageHomeImprovement" [fieldMaxLength]="6"></boi-form-numeric-input>

<!--171.1-->
<ng-container *ngIf="mortgageApplication.RemortgageUse.ReMortgageHomeImprovement && !mortgageApplication.IsAip">
  <boi-form-textarea class="medium-textarea"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.PleaseProvideDetails"
    [propertyNames]="['RemortgageUse.ReMortgageHomeImprovementDetails']"
    [(value)]="mortgageApplication.RemortgageUse.ReMortgageHomeImprovementDetails" [fieldMaxLength]="1500"
    [tooltipName]="referenceDataLabels.ReMortgageHomeImprovementDetails">
  </boi-form-textarea>
</ng-container>

<!--172-->
<boi-form-numeric-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [isCurrency]="true" [propertyNames]="['RemortgageUse.ReMortgageSchoolFeesOrPension']"
  [labelName]="referenceDataLabels.ReMortgageSchoolFeesOrPension"
  [(value)]="mortgageApplication.RemortgageUse.ReMortgageSchoolFeesOrPension" [fieldMaxLength]="6">
</boi-form-numeric-input>

<!--172.1-->
<ng-container *ngIf="mortgageApplication.RemortgageUse.ReMortgageSchoolFeesOrPension && !mortgageApplication.IsAip">
  <boi-form-textarea class="medium-textarea"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.PleaseProvideDetails"
    [propertyNames]="['RemortgageUse.ReMortgageSchoolFeesOrPensionDetails']"
    [(value)]="mortgageApplication.RemortgageUse.ReMortgageSchoolFeesOrPensionDetails" [fieldMaxLength]="1500"
    [tooltipName]="referenceDataLabels.ReMortgageSchoolFeesOrPensionDetails">
  </boi-form-textarea>
</ng-container>

<!--173-->
<boi-form-numeric-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [isCurrency]="true" [propertyNames]="['RemortgageUse.ReMortgageBusinessInvestment']"
  [labelName]="referenceDataLabels.ReMortgageBusinessInvestment"
  [(value)]="mortgageApplication.RemortgageUse.ReMortgageBusinessInvestment" [fieldMaxLength]="6">
</boi-form-numeric-input>

<!--173.1-->
<ng-container *ngIf="mortgageApplication.RemortgageUse.ReMortgageBusinessInvestment && !mortgageApplication.IsAip">
  <boi-form-textarea class="medium-textarea"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.PleaseProvideDetails"
    [propertyNames]="['RemortgageUse.ReMortgageBusinessInvestmentDetails']"
    [(value)]="mortgageApplication.RemortgageUse.ReMortgageBusinessInvestmentDetails" [fieldMaxLength]="1500"
    [tooltipName]="referenceDataLabels.ReMortgageBusinessInvestmentDetails">
  </boi-form-textarea>
</ng-container>

<!--174a-->
<boi-form-numeric-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [isCurrency]="true" [propertyNames]="['RemortgageUse.ReMortgageAdditionalProperty']"
  [labelName]="referenceDataLabels.ReMortgageAdditionalProperty"
  [(value)]="mortgageApplication.RemortgageUse.ReMortgageAdditionalProperty" [fieldMaxLength]="6">
</boi-form-numeric-input>

<!--174.1-->
<ng-container *ngIf="mortgageApplication.RemortgageUse.ReMortgageAdditionalProperty && !mortgageApplication.IsAip">
  <boi-form-textarea class="medium-textarea"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.PleaseProvideDetails"
    [propertyNames]="['RemortgageUse.ReMortgageAdditionalPropertyDetails']"
    [(value)]="mortgageApplication.RemortgageUse.ReMortgageAdditionalPropertyDetails" [fieldMaxLength]="1500"
    [tooltipName]="referenceDataLabels.ReMortgageAdditionalPropertyDetails"></boi-form-textarea>
</ng-container>

<!--175a-->
<boi-form-numeric-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [isCurrency]="true" [propertyNames]="['RemortgageUse.ReMortgageOutrightPropertyPurchase']"
  [labelName]="referenceDataLabels.ReMortgageOutrightPropertyPurchase"
  [(value)]="mortgageApplication.RemortgageUse.ReMortgageOutrightPropertyPurchase" [fieldMaxLength]="6">
</boi-form-numeric-input>

<!--175.1-->
<ng-container
  *ngIf="mortgageApplication.RemortgageUse.ReMortgageOutrightPropertyPurchase && !mortgageApplication.IsAip">
  <boi-form-textarea class="medium-textarea"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.PleaseProvideDetails"
    [propertyNames]="['RemortgageUse.ReMortgageOutrightPropertyPurchaseDetails']"
    [(value)]="mortgageApplication.RemortgageUse.ReMortgageOutrightPropertyPurchaseDetails" [fieldMaxLength]="1500"
    [tooltipName]="referenceDataLabels.ReMortgageOutrightPropertyPurchaseDetails">
  </boi-form-textarea>
</ng-container>

<!--176-->
<boi-form-numeric-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [isCurrency]="true" [propertyNames]="['RemortgageUse.ReMortgageLoanRepayment']"
  [labelName]="referenceDataLabels.ReMortgageLoanRepayment"
  [(value)]="mortgageApplication.RemortgageUse.ReMortgageLoanRepayment"
  [contextualHelpName]="'AppRemortgageLoanRepayment'" [fieldMaxLength]="6"></boi-form-numeric-input>

<!--177-->
<boi-form-numeric-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [isCurrency]="true" [propertyNames]="['RemortgageUse.ReMortgageCostsAndFees']"
  [labelName]="referenceDataLabels.ReMortgageCostsAndFees"
  [(value)]="mortgageApplication.RemortgageUse.ReMortgageCostsAndFees" [fieldMaxLength]="6"></boi-form-numeric-input>

<!--177.1-->
<ng-container *ngIf="mortgageApplication.RemortgageUse.ReMortgageCostsAndFees && !mortgageApplication.IsAip">
  <boi-form-textarea class="medium-textarea"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.PleaseProvideDetails"
    [propertyNames]="['RemortgageUse.ReMortgageCostsAndFeesDetails']"
    [(value)]="mortgageApplication.RemortgageUse.ReMortgageCostsAndFeesDetails" [fieldMaxLength]="1500"
    [tooltipName]="referenceDataLabels.ReMortgageCostsAndFeesDetails">
  </boi-form-textarea>
</ng-container>

<!--178-->
<boi-form-numeric-input
  [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [isCurrency]="true" [propertyNames]="['RemortgageUse.OtherAdditionalRemortgage']"
  [labelName]="referenceDataLabels.OtherAdditionalRemortgage"
  [(value)]="mortgageApplication.RemortgageUse.OtherAdditionalRemortgage" [fieldMaxLength]="6"></boi-form-numeric-input>

<!--179-->
<ng-container *ngIf="mortgageApplication.RemortgageUse.OtherAdditionalRemortgage">
  <boi-form-textarea class="medium-textarea"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
    [labelName]="referenceDataLabels.PleaseProvideDetails"
    [propertyNames]="['RemortgageUse.OtherAdditionalRemortgageDetails']"
    [(value)]="mortgageApplication.RemortgageUse.OtherAdditionalRemortgageDetails" [fieldMaxLength]="1500"
    [tooltipName]="referenceDataLabels.OtherAdditionalRemortgageDetails">
  </boi-form-textarea>
</ng-container>